import { Pipe, PipeTransform } from '@angular/core';
import {OrderDetailsService} from './../../services/order-details/order-details.service';

@Pipe({
  name: 'orderTypeTranslation'
})
export class OrderTypePipe implements PipeTransform {
  constructor(private _order: OrderDetailsService) {}

  transform(o: any, args?: any): any {
    return this._order.isNextOrder(o) ?
      'Next order' : 'Order';
  }

}
